const userDataFormIT = {
    "view": {
        "title": "Completa le tue informazioni",
        "stepZero": {
            "title": "Dichiarazione",
            "form": {
                "label": {
                    "declarationPoint1": "Fornendo queste informazioni, riconosci e accetti che saranno fornite al meglio delle tue conoscenze e capacità. Ci impegniamo a garantire che tutte le informazioni siano accurate e veritiere.",
                    "declarationPoint2": "Si prega di essere consapevoli che fornire informazioni false o rappresentare in modo errato la verità può avere conseguenze significative. Invitiamo tutti gli utenti a verificare le informazioni che forniscono e a utilizzare questa piattaforma in modo responsabile.",
                    "declarationPoint3": "La responsabilità per qualsiasi disinformazione o errore ricade esclusivamente sull'individuo che fornisce le informazioni. Non ci assumiamo alcuna responsabilità per le conseguenze di informazioni errate o fuorvianti fornite dagli utenti.",
                    "declarationPoint4": "Cliccando su <strong>'Avanti'</strong>, acconsenti a questi termini e affermi di essere pienamente consapevole delle implicazioni di fornire informazioni inaccurate o false.",
                    "declarationAgreement": "Accetto pienamente e comprendo i termini sopra indicati."
                },
                "button": {
                    "next": "Avanti"
                }
            }
        },
        "stepOne": {
            "title": "Informazioni personali",
            "form": {
                "label": {
                    "firstName": "Nome",
                    "lastName": "Cognome",
                    "streetAndNumber": "Via e Numero",
                    "zipCode": "CAP",
                    "city": "Città",
                    "country": "Paese"
                },
                "placeholder": {
                    "country": "Seleziona Paese"
                },
                "help_text": {
                    "firstName": "Se ti registri come LLC o altra entità commerciale, questo campo verrà utilizzato per il Nome del CEO.",
                    "lastName": "Se ti registri come LLC o altra entità commerciale, questo campo verrà utilizzato per il Cognome del CEO.",
                    "country": "Se ti registri come LLC o altra entità commerciale, questo campo verrà utilizzato per il Paese del CEO."
                },
                "button": {
                    "next": "Avanti"
                }
            }
        },
        "stepTwo": {
            "title": "Informazioni aziendali",
            "form": {
                "label": {
                    "businessType": "Tipo di attività",
                    "companyName": "Nome dell'azienda",
                    "businessStreet": "Via e Numero",
                    "businessCity": "Città",
                    "businessZip": "CAP",
                    "businessCountry": "Paese",
                    "ceoFirstName": "Nome del Rappresentante Legale / CEO",
                    "ceoLastName": "Cognome del Rappresentante Legale / CEO",
                    "tradeRegistryExport": "Esportazione del Registro delle Imprese",
                    "tradeRegistryCompanyUrl": "URL del Registro delle Imprese",
                    "vatNumber": "Partita IVA",
                    "taxNumber": "Codice Fiscale"
                },
                "option": {
                    "businessType": {
                        "soleProprietorship": "Ditta individuale",
                        "limitedLiabilityCompany": "Società a responsabilità limitata",
                        "partnershipOrganized": "Società organizzata",
                        "publicLimitedCompanyByShares": "Società per azioni",
                        "other": "Altro"
                    }
                },
                "placeholder": {
                    "businessType": "Seleziona Tipo di Attività",
                    "businessCountry": "Seleziona Paese"
                },
                "help_text": {
                    "companyName": "Il nome dell'azienda deve essere coerente con quanto inizialmente presentato in Stripe. Cambia solo se differisce da quanto inizialmente presentato.",
                    "tradeRegistryExport": "Si prega di fornire un'esportazione ufficiale del registro delle imprese della tua azienda. Solo PDF, dimensione massima del file 5 MB. Se hai bisogno di aiuto per trovare l'esportazione del tuo registro delle imprese, contatta il registro nel tuo paese. Un elenco non ufficiale dei registri può essere trovato <1>qui</1>.",
                    "tradeRegistryCompanyUrl": "Si prega di fornire l'URL della tua azienda nel registro delle imprese del tuo paese. Se il tuo registro non supporta questo, inserisci solo un URL del registro."
                },
                "button": {
                    "previous": "Precedente",
                    "next": "Avanti"
                }
            }
        },
        "stepThree": {
            "title": "Conferma",
            "form": {
                "label": {
                    "personalInformation": "Informazioni personali",
                    "personalName": "Nome",
                    "personalAddress": "Indirizzo",
                    "businessInformation": "Informazioni aziendali",
                    "companyName": "Azienda",
                    "ceoName": "Nome del CEO",
                    "businessAddress": "Indirizzo",
                    "businessType": "Tipo di attività",
                    "taxNumber": "Codice Fiscale",
                    "vatNumber": "Partita IVA",
                    "tradeRegistryExportUploaded": "Esportazione del Registro delle Imprese Caricata",
                    "tradeRegistryCompanyUrl": "URL del Registro delle Imprese",
                    "notAvailable": "N/D"
                },
                "button": {
                    "previous": "Precedente",
                    "save": "Salva",
                    "next": "Avanti"
                }
            },
            "message": {
                "success": "Le tue informazioni sono state aggiornate!",
                "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
            },
            "modal": {
                "submitYourInformation": {
                    "header": "Invia le tue informazioni",
                    "body": {
                        "point1": "Cliccando su <strong>'Conferma'</strong>, stai affermando che tutte le informazioni che hai fornito sono accurate e veritiere al meglio delle tue conoscenze.",
                        "point2": "Confermi che tutti i dettagli forniti sono corretti e riconosci le potenziali conseguenze di inviare informazioni inaccurate?"
                    },
                    "button": {
                        "confirm": "Conferma",
                        "cancel": "Annulla"
                    }
                }
            }
        },
        "stepFour": {
            "title": "Verifica numero di cellulare",
            "form": {
                "label": {
                    "mobileNumber": "Inserisci il tuo numero di cellulare",
                    "deliveryMedium": "Mezzo di consegna: ",
                    "deliveryMediumSMS": "SMS",
                    "deliveryMediumWhatsapp": "WhatsApp",
                    "otp": "OTP"
                },
                "help_text": {
                    "mobileNumber": "Nota: Il numero di cellulare è richiesto per la verifica come procedura standard perché può essere utilizzato per la convalida dell'accesso. Devi possedere il numero e avere accesso ad esso per un processo di verifica fluido.",
                    "isFormUSorCanada": "* Se sei basato negli Stati Uniti o in Canada, contatta il nostro team di supporto dopo aver inserito il tuo numero di cellulare.",
                    "deliveryMediumWhatsapp": "Nota: Assicurati di avere un account WhatsApp su questo numero per ricevere il messaggio.",
                    "otp": "Inserisci l'OTP inviato al tuo numero di cellulare."
                },
                "message": {
                    "errorMobileNumberEmpty": "Il numero di cellulare è richiesto.",
                    "errorMobileNumberInvalid": "Numero di cellulare non valido.",
                    "errorMobileNumberSame": "Questo numero è già stato aggiunto e verificato con il tuo account.",
                    "errorOTPRequired": "OTP è richiesto.",
                    "errorOtpSendLimitExhasuted": "Non puoi richiedere ulteriori OTP poiché hai esaurito il <strong>limite massimo ({{maxLimit}})</strong> per le richieste di OTP. Contatta il supporto per ulteriori informazioni!",
                    "errorMobileUpdateLimitExhausted": "Non puoi aggiornare il tuo numero di cellulare poiché lo hai già aggiornato il massimo ({{maxLimit}}) delle volte. Contatta il supporto per ulteriori informazioni!"
                },
                "button": {
                    "sendOTP": "Invia OTP",
                    "next": "Avanti",
                    "confirm": "Conferma",
                    "notGettingCode": "Non ricevo il codice"
                }
            },
            "message": {
                "success": "Numero di cellulare verificato!",
                "errorValidatingOTP": "Errore nella convalida dell'OTP!",
                "errorSendingOTP": "Si è verificato un problema nell'invio del codice OTP, riprova più tardi!"
            },
            "modal": {
                "notGettingCode": {
                    "header": "Non ricevo il codice",
                    "body": {
                        "point1": "Sembra che ci sia un problema nell'inviarti un codice di verifica in questo momento. Riprova più tardi",
                        "point2": "Per assistenza, contatta il nostro supporto tramite il Centro Assistenza."
                    },
                    "button": {
                        "close": "Chiudi"
                    }
                }
            },
            "resendTimer": {
                "message": {
                    "secondsRemaining": "Puoi richiedere nuovamente l'OTP tra <strong>{{secondsRemaining}}</strong> secondi"
                }
            }
        },
        "stepFive": {
            "title": "Verifica dell'identità",
            "form": {
                "label": {
                    "identityVerificationDescription": "Clicca sul link qui sotto per avviare la Verifica dell'Identità.",
                    "identityVerificationResults": "Risultati della Verifica dell'Identità"
                },
                "button": {
                    "loading": "Caricamento...",
                    "verifyIdentity": "Verifica Identità"
                },
                "table": {
                    "column": {
                        "type": "Tipo",
                        "status": "Stato",
                        "details": "Dettagli"
                    },
                    "label": {
                        "selfieVerification": "Verifica Selfie",
                        "documentVerification": "Verifica Documento",
                        "verified": "Verificato",
                        "notVerified": "Non Verificato",
                        "notAvailable": "N/D"
                    }
                },
                "message": {
                    "identityVerificationSuccess": "Le informazioni sulla tua identità sono state verificate, il nostro team esaminerà le informazioni sull'identità e darà l'approvazione finale in 2-3 giorni lavorativi.",
                    "identityVerificationFailed": "Le informazioni sulla tua identità non possono essere verificate, gentilmente invia nuovamente le informazioni! Hai solo <strong>{{attemptsRemaining}}</strong> tentativi rimanenti per verificare la tua identità.",
                    "identityVerificationMaxAttempts": "Hai esaurito il numero massimo di tentativi per la Verifica dell'Identità, contatta il supporto per ulteriori informazioni."
                }
            }
        },
        "stepSix": {
            "title": "Firma il contratto",
            "form": {
                "label": {
                    "signContract": "Firma il contratto"
                }
            }
        },
        "stepSeven": {
            "title": "Approvazione",
            "form": {
                "message": {
                    "approval": "Il nostro team esaminerà tutte le informazioni fornite da te e darà l'approvazione finale entro 3 giorni lavorativi."
                }
            }
        }
    },
    "signRedirectPages": {
        "signSuccess": {
            "title": "Firma del contratto avvenuta con successo :)",
            "description": "Hai firmato con successo il tuo contratto, lo stato verrà aggiornato nel tuo account a breve, aggiorna la pagina tra pochi secondi."
        },
        "signLater": {
            "title": "Firma del contratto più tardi ...",
            "description": "Hai scelto di firmare il contratto più tardi, completa questo passaggio al più presto per usufruire della distribuzione."
        },
        "signDeclined": {
            "title": "Firma del contratto rifiutata :(",
            "description": "Hai rifiutato di firmare il contratto, questo ritarderà il processo per abilitare la distribuzione."
        },
        "signCompleted": {
            "title": "Firma del contratto completata :)",
            "description": "Il tuo contratto è stato finalizzato, lo stato verrà aggiornato nel tuo account a breve, aggiorna la pagina tra pochi secondi."
        }
    }
};

export default userDataFormIT;